/* © CNES */
import { Dialog } from 'primereact/dialog';
import { ProgressBar } from 'primereact/progressbar';
import { useContext, useEffect, useState } from 'react';
import { ConfigContext } from '../../../context/ConfigContext';
/**
 * Dialog to display progress bar when a product/job is being downloaded.
 * @param downloadProgress progress in percent for downloads running.
 * @returns Element.
 */
export const DownloadProgressDialog = ({
  downloadProgress,
}: {
  downloadProgress: number | null;
}) => {
  const context = useContext(ConfigContext);
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const [hiddenByUser, setHiddenByUser] = useState<boolean>(false);

  /**
   * Evaluate downloadProgress to trigger dialog display.
   */
  useEffect(() => {
    if (downloadProgress && !showDialog && !hiddenByUser) {
      setShowDialog(true);
    }

    if (downloadProgress === 100) {
      setShowDialog(false);
    }

    if (context.downloadingProducts.length === 0) {
      setShowDialog(false);
      setHiddenByUser(false);
    }

    // eslint-disable-next-line
  }, [context.downloadingProducts, hiddenByUser, downloadProgress]);

  const handleCloseAction = () => {
    setHiddenByUser(true);
    setShowDialog(false);
  };

  return (
    <Dialog
      visible={showDialog}
      position="top"
      style={{ width: '30vw' }}
      onHide={() => handleCloseAction()}
      draggable={false}
      resizable={false}
      modal={false}
      baseZIndex={10000}
      headerStyle={{ height: '10px' }}
    >
      <div>
        <span
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: '5px',
          }}
        >
          Product is being prepared for download...
        </span>
        <ProgressBar
          value={downloadProgress}
          displayValueTemplate={() => ''}
        ></ProgressBar>
      </div>
    </Dialog>
  );
};
